import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
// 买单吧页面路由
var MaidanbaShowHome = function MaidanbaShowHome() {
  return import('@/pages/maidanba/maidanba.vue');
};
export default [{
  //  mdb ==> maidanba 买单吧APP 演出内嵌
  path: '/mdb',
  component: MaidanbaShowHome,
  children: [{
    // 演出授权页
    path: 'auth*',
    name: 'maidanbaAuth',
    component: function component() {
      return import('@/pages/maidanba/auth.vue');
    }
  }]
}];